import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mod_pagin" }

import { reactive, ref } from 'vue';
import { Table, Pagination, message } from 'ant-design-vue';
import { LuckeyRecordColumn } from '@/types/application/FiveLuckyGame';
import fiveLuckyApi from '@/api/application/fiveLuckyGame';
import { useDebounce } from '@/hooks/useDebounce';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LuckyRecord',
  setup(__props) {

const aTable = Table;
const aPagination = Pagination;
const route = useRoute();
const router = useRouter();

// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 1, // 总页数
  options: ['10', '20', '30', '40', '50'], // 选项
});

const columns = [
  // {
  //   title: '用户头像',
  //   dataIndex: 'avatar',
  //   key: 'avatar',
  //   align: 'center',
  //   slots: { customRender: 'avatar' },
  // },
  {
    title: '用户昵称',
    dataIndex: 'name',
    key: 'name',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '开奖时间',
    dataIndex: 'created_at',
    key: 'created_at',
    align: 'center',
  },
];
const list = ref<LuckeyRecordColumn[]>([]);

const showLoading = ref(true);
const getList = useDebounce(() => {
  if (!route.query?.id) {
    message.error('无效的链接地址，请重试！');
    setTimeout(() => {
      router.push({ name: 'FiveLuckyGame' });
    }, 2000);
  }
  // showLoading.value = true;
  const search = {
    id: route.query?.id,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  fiveLuckyApi
    .getLuckyRecord({ params: search })
    .then((res) => {
      if (res.data.data?.data) {
        list.value = res.data.data.data;
        pageConfig.current = res.data.data.current_page;
        pageConfig.totalSize = res.data.data.total;
      } else {
        list.value = [];
        pageConfig.current = 1;
        pageConfig.totalSize = 1;
      }
    })
    .catch((err) => {
      message.error(err.data.error);
    })
    .finally(() => {
      showLoading.value = false;
    });
});
getList();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(aTable), {
        loading: showLoading.value,
        columns: columns,
        "data-source": list.value,
        pagination: false,
        "row-key": "id"
      }, {
        avatar: _withCtx(({ record }) => [
          _createElementVNode("img", {
            src: record.avatar,
            alt: "",
            class: "avatar"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["loading", "data-source"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(aPagination), {
        "show-quick-jumper": "",
        total: pageConfig.totalSize,
        current: pageConfig.current,
        "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.current) = $event)),
        "page-size": pageConfig.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig.pageSize) = $event)),
        pageSizeOptions: pageConfig.options,
        "show-less-items": "",
        "show-size-changer": "",
        onChange: _unref(getList),
        onShowSizeChange: _unref(getList)
      }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"])
    ], 512), [
      [_vShow, pageConfig.totalSize > pageConfig.pageSize]
    ])
  ]))
}
}

})